import { useEffect } from "react";
import AppLoader from "../../../../commons/components/Loader";
import { AppBox, AppTitle } from "../../../../commons/components";
import { useNavigate } from "react-router";

const MicrosoftLogout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    setTimeout(() => {
      navigate("/");
    }, 2000);
  }, []);

  return (
    <AppBox>
      <AppLoader size="lg" />
      <AppTitle
        as="h3"
        color="accent"
        size="lg"
        style={{
          position: "absolute",
          top: "60%",
          left: "50%",
          transform: "translate(-50%,-60%)",
        }}
      >
        Logging out....
      </AppTitle>
    </AppBox>
  );
};

export default MicrosoftLogout;
